<i18n>
{
  "fr":{
    "Name": "Projets"
  }
}
</i18n>

<template>
  <section>
    <BaseForm>
      <BaseSelect
        :label="$t('Name')"
        :options="formattedList"
        :validate="validate"
        @input="v=>$emit('input', v)" />
    </BaseForm>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    validate: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('projects', ['projects']),
    formattedList() {
      if (this.projects) {
        return this.projects.map(project => ({
          label: project.name,
          value: project.name,
        }));
      }

      return null;
    },
  },
  created() {
    this.$store.dispatch('projects/getList');
  },
};
</script>
